import RadioItemList from './RadioItemList';
import { RadioItemListProps, RadioItemListValueProps } from './types';

export type { RadioItemListProps, RadioItemListValueProps };
export default RadioItemList;
